module.exports = __webpack_public_path__ + "img/main_1.facad8b6.png";